import React from "react";
import dayjs from 'dayjs';

export function formatPhoneNumber(number) {
    if (!number) {
        return "";
    }
    const cleaned = ('' + number).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return number;
}

export const displayMentorStatus = (userType) => {
    switch (userType) {
        case "REQUESTED": return <span style={{color: "red"}}>멘토 승인요청</span>
        case "REJECTED": return <span>멘토 승인반려</span>
        case "APPROVED": return <span style={{color: "blue"}}>멘토 승인완료</span>
        default: return <span>-</span>
    }
}

export const displayUserState = (userState) => {
    switch (userState) {
        case "INIT": return <span>유저 생성</span>
        case "PROVIDER_PENDING": return <span style={{color: "orange"}}>공급자 승인 대기</span>
        case "PROVIDER_REJECT": return <span style={{color: "red"}}>공급자 반려</span>
        case "PROVIDER_AUTHORIZED": return <span style={{color: "blue"}}>공급자 승인 완료</span>
        case "PROVIDER_UPDATE": return <span style={{color: "orange"}}>공급자 정보 업데이트 중</span>
        case "BANNED": return <span style={{color: "gray"}}>정지</span>
        case "WITHDRAWN": return <span style={{color: "gray"}}>탈퇴</span>
        case "ADMIN_WITHDRAWN": return <span style={{color: "gray"}}>강제 탈퇴</span>
        default: return <span>-</span>
    }
}

export const displayUserRole = (role) => {
    switch (role) {
        case "CONSUMER": return "수요자"
        case "PROVIDER": return "공급자"
        case "ADMIN": return "관리자"
        default: return role
    }
}

export const displayPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || phoneNumber.length !== 11) {
        return phoneNumber;
    }
    return  phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
}

export function formatCurrency(number) {
    if (!number) {
        return "";
    }

    return number.toLocaleString('ko-KR');
}

export function formatDate(date, format = 'YYYY-MM-DD HH:mm') {
    if (!date) {
        return date;
    }
    return dayjs(date).format(format);
}

export const displayConsumerCareerStatus = (status) => {
    switch (status) {
        case "EMPLOYED": return "재직 중"
        case "JOB_SEEKING": return "취업 준비 중"
        case "STUDENT": return "학생"
        case "CAREER_BREAK": return "경력 단절"
        default: return status
    }
}

export const displayProviderCareerStatus = (status) => {
    switch (status) {
        case "EMPLOYED": return "재직 중"
        default: return status
    }
}

export const displayProviderServiceYears = (years) => {
    switch (years) {
        case "JUNIOR": return "주니어"
        case "MID": return "미들"
        case "SENIOR": return "시니어"
        default: return years
    }
}

export const displayReportStatus = (status) => {
    switch (status) {
        case "PENDING":
            return <span style={{color: "red"}}>검토 대기</span>;
        case "REVIEWED":
            return <span style={{color: "green"}}>검토 완료</span>;
        default:
            return status;
    }
}
